export default function SendIcon() {
  return (
    <svg width='13' height='14' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.499878' width='4.33332' height='4.33332' fill='currentColor' />
      <rect x='4.33398' y='0.499878' width='4.33332' height='4.33332' fill='currentColor' />
      <rect x='8.66602' y='0.499878' width='4.33332' height='4.33332' fill='currentColor' />
      <rect x='8.66602' y='4.83301' width='4.33332' height='4.33332' fill='currentColor' />
      <rect x='8.66602' y='9.16675' width='4.33332' height='4.33332' fill='currentColor' />
      <rect y='9.16675' width='4.33332' height='4.33332' fill='currentColor' />
    </svg>
  )
}
